/** Country names, once (plan 1-3): the old pages each kept their own
 *  `Intl.DisplayNames`. AdMob reports an empty code for traffic it could not
 *  place; that is 미상. */

const regionNames = (() => {
  try {
    return new Intl.DisplayNames(['ko'], { type: 'region' })
  } catch {
    return null
  }
})()

/** The empty code's name. */
export const UNKNOWN_COUNTRY = '미상'

/** "KR" → "대한민국"; "" → "미상"; a code Intl does not know stays as is. */
export function countryName(code: string | null | undefined): string {
  const c = (code ?? '').trim().toUpperCase()
  if (!c || c === 'ZZ' || c === 'XX') return UNKNOWN_COUNTRY
  try {
    return regionNames?.of(c) ?? c
  } catch {
    return c
  }
}
